import { createApp, defineAsyncComponent, h } from 'vue'
import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import router from './router'
import App from './App.vue'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import style from './style.css'
import i18n from './i18n';

let domain = window.location.protocol + '//' + window.location.host + '/';
window['domain'] = domain;

try {
    //axios.defaults.headers.common['Authorization'] = 'Basic cHJvZml0OmtpdA==';
    axios.defaults.baseURL = domain;

    // Добавляем интерсептор для обработки ошибок авторизации
    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          // Если сервер вернул 401, сбрасываем авторизацию
          store.dispatch('logout')
          router.push('/auth/')
        }
        return Promise.reject(error)
      }
    )

        const app2 = createApp(App)
        app2.use(i18n);
        app2.use(router)
        app2.use(store)
        app2.use(VueAxios, axios)
        app2.mount('#app')
}
catch (err) {
    let form = new FormData();
    form.append("useragent", window.navigator.userAgent)
    form.append("date", new Date());
    form.append("error", err);
    let response = fetch(domain+'api/log/', {
        method: 'POST',
        body: form
    });
}



